interface RatingStarsProps {
  rating: number;
  count?: number;
  showValue?: boolean;
}

export default function RatingStars({ rating, count, showValue = true }: RatingStarsProps) {
  const rounded = Math.round(rating * 2) / 2;

  return (
    <div className="flex items-center gap-1.5">
      <span className="flex items-center gap-0.5 text-accent-500">
        {[1, 2, 3, 4, 5].map((star) => {
          const icon =
            rounded >= star
              ? "ri-star-fill"
              : rounded >= star - 0.5
                ? "ri-star-half-fill"
                : "ri-star-line";
          return (
            <span key={star} className="flex h-4 w-4 items-center justify-center">
              <i className={`${icon} text-sm`} />
            </span>
          );
        })}
      </span>
      {showValue ? (
        <span className="text-sm font-semibold text-foreground-800">{rating.toFixed(1)}</span>
      ) : null}
      {typeof count === "number" ? (
        <span className="text-xs text-foreground-500">({count.toLocaleString("en-IN")})</span>
      ) : null}
    </div>
  );
}